@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <!-- Header -->
  <div class="mb-3 flex items-center justify-between">
    <div class="flex items-center gap-2">
      <mat-icon class="!text-base text-violet-600">poll</mat-icon>
      <h3 class="text-secondary text-sm font-semibold uppercase tracking-wide">Active Surveys</h3>
    </div>
    <div class="flex items-center gap-2">
      @if (data?.total_active) {
        <span class="rounded-full px-2 py-0.5 text-[10px] font-semibold" [ngClass]="data.total_active | countBadge">{{ data.total_active }} active</span>
      }
      @if (data) {
        <button class="text-xs font-medium text-blue-600 hover:underline" (click)="navigateToAll()">View all →</button>
      }
    </div>
  </div>

  @if (loading) {
    <div class="space-y-2">
      @for (_ of [1, 2, 3]; track $index) {
        <div class="h-14 animate-pulse rounded-lg bg-gray-100"></div>
      }
    </div>
  } @else if (error) {
    <div class="flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">
      <mat-icon class="!text-base">error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
  } @else if (!data || !data.surveys?.length) {
    <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
      <mat-icon class="!text-3xl text-gray-300">poll</mat-icon>
      <span class="text-xs text-gray-400">No active surveys at the moment</span>
    </div>
  } @else {
    <div class="divide-y divide-gray-50">
      @for (s of data.surveys; track s.id) {
        @let days = getDaysUntilExpiry(s.expire_at);
        <div class="group flex cursor-pointer items-start gap-2.5 py-2.5 transition-colors hover:bg-gray-50" (click)="navigateToSurvey(s.id)">
          <!-- Icon badge -->
          <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-violet-50">
            <mat-icon class="!text-sm text-violet-600">poll</mat-icon>
          </div>

          <!-- Content -->
          <div class="min-w-0 flex-1">
            <!-- Title + community -->
            <div class="truncate text-xs font-semibold text-gray-800" [matTooltip]="s.title">{{ s.title }}</div>
            <div class="mt-0.5 text-[10px] text-gray-400">{{ s.community_name ?? 'All communities' }}</div>

            <!-- Participation bar -->
            <div class="mt-1.5 flex items-center gap-1.5">
              <div class="h-1.5 flex-1 overflow-hidden rounded-full bg-gray-100">
                <div
                  class="h-full rounded-full transition-all"
                  [class.bg-green-500]="s.participation_pct >= 75"
                  [class.bg-yellow-400]="s.participation_pct >= 40 && s.participation_pct < 75"
                  [class.bg-red-400]="s.participation_pct < 40"
                  [style.width.%]="s.participation_pct"
                ></div>
              </div>
              <span class="shrink-0 text-[10px] font-semibold text-gray-500">{{ s.participation_pct }}%</span>
            </div>
          </div>

          <!-- Right: responses + expiry -->
          <div class="shrink-0 text-right">
            <div class="text-xs font-bold text-gray-700">
              {{ s.responses }}<span class="font-normal text-gray-400">/{{ s.contacts }}</span>
            </div>
            <div class="mt-0.5 text-[10px] font-semibold" [class.text-red-500]="days <= 3" [class.text-orange-500]="days > 3 && days <= 7" [class.text-gray-400]="days > 7">{{ days }} d left</div>
          </div>

          <!-- Chevron -->
          <mat-icon class="flex-shrink-0 !text-sm text-gray-300 opacity-0 transition-all group-hover:text-primary group-hover:opacity-100">chevron_right</mat-icon>
        </div>
      }
    </div>
  }
}
